export const GET_CURRENT_PAGES = 'GET_CURRENT_PAGES';


